module.exports = __webpack_public_path__ + "img/4-gallery.76428af6.jpg";